module.exports = __webpack_public_path__ + "static/img/1-active.f98434fd.png";